import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n";
import api from "../lib/api";
import { mediaUrl } from "../lib/api";
import { Reveal } from "../components/motion";

const Blog = () => {
  const { t, lang } = useLang();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then(({ data }) => setPosts(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="blog-page" className="pt-36 pb-28 max-w-[1400px] mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="text-primary/70 text-xs uppercase tracking-[0.25em] mb-6">{t("nav.blog")}</p>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tightest text-foreground mb-4">{t("blog.title")}</h1>
        <p className="text-foreground/65 font-light text-lg max-w-xl mb-16">{t("blog.sub")}</p>
      </Reveal>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {posts.map((p, i) => (
          <Reveal key={p.slug} delay={(i % 3) * 0.08}>
            <Link to={`/blog/${p.slug}`} data-testid={`post-${p.slug}`} className="group block">
              <div className="h-64 overflow-hidden mb-5 rounded-3xl">
                <img src={mediaUrl(p.image)} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="flex items-center gap-3 text-xs text-foreground/50 mb-3 uppercase tracking-wider">
                <span className="text-primary">{p.category[lang]}</span>
                <span>·</span>
                <span>{p.read}</span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl text-foreground leading-tight mb-3 group-hover:text-primary transition-colors">{p[lang].title}</h2>
              <p className="text-foreground/60 font-light text-sm mb-4">{p[lang].excerpt}</p>
              <span className="inline-flex items-center gap-1.5 text-sm text-primary font-medium">{t("blog.read")} <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" /></span>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  );
};

export default Blog;
